// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar-module--sidebar--hnLwc","active-link":"sidebar-module--active-link--bTNsb","activeLink":"sidebar-module--active-link--bTNsb"};